<template>
  <div class="col-md-8 mb-3">
    <b-card>
      <b-card-text>
        <h5 class="font-weight-bold">
          {{ $t("dashboard.pendingDocuments") }}
        </h5>
      </b-card-text>

      <table class="portal-table portal-table-responsive">
        <thead>
          <tr>
            <th>{{ $t("documents.table.name") }}</th>
            <th>{{ $t("documents.table.sentAt") }}</th>
            <th>{{ $t("documents.table.sentBy") }}</th>
            <th></th>
          </tr>
        </thead>

        <tbody>
          <tr
            class="portal-table-row"
            v-for="item in documentsList"
            :key="'doc' + item.id"
          >
            <template v-if="item.form !== undefined">
              <td :data-label="translate.name">
                {{ item.form.showInOmt ? "Assessment" : item.form.name }}
              </td>
              <td :data-label="translate.sentAt">
                {{ item.sentAt | formatDate }}
              </td>
              <td :data-label="translate.sentBy">
                {{ item.sentBy ? item.sentBy.fullName : "" }}
              </td>
              <td align="right">
                <form-button
                  v-if="item.readOnly || !item.requestUpload"
                  :status="item.document ? item.document.status : 'Pending'"
                  :readOnly="item.readOnly"
                  @editDocument="handleOpenDocument(item.id)"
                />
                <form-button
                  v-else
                  :status="item.document ? item.document.status : 'Pending'"
                  :readOnly="item.readOnly"
                  @editDocument="openFileUploadModal(item.id)"
                />
              </td>
            </template>

            <template v-else-if="item.formGroup !== undefined">
              <td :data-label="translate.name">{{ item.formGroup.name }}</td>
              <td :data-label="translate.sentAt">
                {{ item.sentAt | formatDate }}
              </td>
              <td :data-label="translate.sentBy">{{ item.sentBy.fullName }}</td>
              <td>
                <form-button
                  v-if="item.readOnly || !item.requestUpload"
                  :status="item.document ? item.document.status : 'Pending'"
                  :readOnly="item.readOnly"
                  @editDocument="handleOpenDocumentGroup(item.id)"
                />
                <form-button
                  v-else
                  :status="item.document ? item.document.status : 'Pending'"
                  :readOnly="item.readOnly"
                  @editDocument="openFileUploadModal(item.id, true)"
                />
              </td>
            </template>
          </tr>

          <tr v-if="!documentsLoaded">
            <td colspan="6" align="center">
              <div class="d-flex flex-row justify-content-center mt-4 mb-4">
                <b-spinner
                  style="width: 4rem; height: 4rem"
                  variant="primary"
                  label="Spinning"
                ></b-spinner>
              </div>
            </td>
          </tr>

          <tr v-if="documentsLoaded && documentsList.length === 0">
            <td colspan="4" align="center">NO DOCUMENTS</td>
          </tr>
        </tbody>
      </table>
      <document-file-upload-modal
        v-if="fileUploadModal"
        v-model="fileUploadModal"
        @onModify="closeFileUploadModal"
        :sharedDocumentId="selectedSharedDocumentId"
        :isFormGroup="isFormGroup"
      />
    </b-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import FormButton from "../../views/FormButton.vue";
import documentServer from "../../server/document";
import DocumentFileUploadModal from "../documents/DocumentFileUploadModal.vue";

export default {
  name: "HomePendingDocuments",
  components: {
    FormButton,
    DocumentFileUploadModal
  },
  data() {
    return {
      fileUploadModal: false,
      selectedSharedDocumentId: null,
      isFormGroup: false
    };
  },
  methods: {
    ...mapActions("session", ["loadDocuments"]),
    handleOpenDocument(docId) {
      const sharedDocument = this.documents.find(d => d.id == docId);
      if (sharedDocument.document && sharedDocument.document.mode == "File") {
        const url = documentServer.viewUrl(sharedDocument.document.id);
        window.open(url, "_blank");
      } else {
        this.$router.push("/document/" + docId);
      }
    },
    handleOpenDocumentGroup(docId) {
      this.$router.push("/document_group/" + docId);
    },
    openFileUploadModal(sharedDocumentId, isFormGroup = false) {
      this.selectedSharedDocumentId = sharedDocumentId;
      this.isFormGroup = isFormGroup;
      this.fileUploadModal = true;
    },
    closeFileUploadModal() {
      this.fileUploadModal = false;
      this.selectedSharedDocumentId = null;
      this.loadDocuments();
    }
  },
  computed: {
    ...mapGetters("session", ["documents", "documentsLoaded"]),
    documentsList() {
      const documents = this.documents;
      return documents.filter(item => {
        if (item.readOnly) return false;
        if (!item.document) return true;
        return item.document.status.toLowerCase() !== "completed";
      });
    },
    translate() {
      return {
        name: this.$t("documents.table.name"),
        sentAt: this.$t("documents.table.sentAt"),
        sentBy: this.$t("documents.table.sentBy")
      };
    }
  }
};
</script>

<style></style>
